/* eslint-disable */
import { MenuItem, Select } from "@mui/material";
import { forwardRef } from "react";

const CustomSelect = forwardRef(({name, list, labelName, onChange, ...restProps}, ref) => {
    return (
        <Select
            {...restProps}
            ref={ref}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                PaperProps: {
                    sx: {
                        transform: 'translateX(5px)',
                    },
                },
            }}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            onChange={onChange}
        >
            <MenuItem 
            key="empty"
            value={''}>
                {labelName}
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
                {opt.name}
            </MenuItem> 
            ))}
        </Select>
    );
});

export default CustomSelect;